module.exports = __webpack_public_path__ + "img/thanks-order.678c56ac.png";